import gql from 'graphql-tag'

export const queryContractTypeByPk = id => {
	return {
		query: gql`
			query ($id: bigint!) {
				conf_contract_types_by_pk(id: $id) {
					type
					id
				}
			}
		`,
		update(data) {
			return data.conf_contract_types_by_pk.type
		},
		variables: {
			id: parseInt(id)
		}
	}
}
